import { gql } from "@apollo/client";

export const USER_CONFIG = gql`
  query UserConfig {
    userConfig {
      api_server_host
      corp_api_server_host
      oauth_client_id
      oauth_connector_id
      oauth_issuer
      ui_server_host
      user
    }
  }
`;
